import React, {Component} from 'react';

class Logout extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    this.props.mainCtrl.logoutSuccess();
    this.props.mainCtrl.setState({
      token:"",loginID:0,message:"Logout Successful"
    });
    this.props.history.push("/");
    //{this.setState({token:"",loginID:0,message:"Logout Successful"});return null} 
  }
  render() {
    return (
      null
    );
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/views/Pages/Logout/Logout.js